/*
 * @Author: your name
 * @Date: 2021-09-23 10:39:56
 * @LastEditTime: 2021-09-24 15:23:57
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\account\api.js
 */
export const api = {
  account: {
    accountAdd: '/cms/account/add.json', // 新增账户
    queryAccouts: '/cms/account/queryResultsByPag.json', // 按照条件查询账户信息
    accountDel: '/cms/account/delete.json', // 删除账户
    accountUpdate: '/cms/account/update.json', // 修改账户信息
    accountRestPwd: '/cms/account/resetPassword.json', //  重置密码
    queryRlatAcctGroup: '/cms/account/queryRlatAcctGroup.json', //查询账号关联的账户组
    queryAccGroup: '/cms/accountGroup/queryResultsByPageApi.json', // 查询账户组信息
    addRelations: '/cms/account/addRelations.json', // 关联账户组
    editPassWord: '/cms/account/adminModifyPassword.json',
    accountUpdateStatus: '/cms/account/updateStatus.json',
    getPersonList: '/vas/personnel/queryPersonListApi.json', //获取员工列表
    batchFileload: '/common/file/batchFileload.json', // 上传图片
    getPersonListNew: '/vas/personnel/queryAccountPersonList.json', //获取员工列表
    queryAccountDetail: '/cms/account/queryDetails.json', //获取员工列表', //获取账户详情
  },
  permission: {
    list: '/cms/account/queryAssociationalDeviceTree.json', // 获取区域
    queryArea: '/cms/area/queryAreaDevGroupList/queryAreaDevGroups.json', // 搜索区域
    queryDeviceList: '/cms/account/getDeviceList.json', // 获取区域下所有设备
    setAreaList: '/cms/account/setAreaDevGroups.json', // 设置区域权限
    setDeviceList: '/cms/account/setDevicePermissions.json' // 设置设备权限
  },
  group: {
    queryAuthGroupList: '/cms/authgroup/queryAuthGroupList.json', //查询设备权限组列表
    addAuthGroup: '/cms/authgroup/addAuthGroup.json', //新增权限组
    updateAuthGroup: '/cms/authgroup/updateAuthGroup.json', //修改权限组
    deleteAuthGroup: '/cms/authgroup/deleteAuthGroup.json', //删除权限组
    // queryAreaDevGroupTree: '/cms/authgroup/queryAreaDevGroupTree.json', //查询区域树

    queryDeviceWorkGroup: '/bms/device/queryDeviceWorkGroup.json', //查询设备组树
    queryDeviceList: '/cms/authgroup/queryDeviceList.json', //查询设备列表
    updateAuthGroupAuthority: '/cms/authgroup/updateAuthGroupAuthority.json', //修改权限组权限配置
    // queryAuthGroupDetail: '/cms/authgroup/queryAuthGroupDetail.json', //查询权限组详情接口

    queryAccountAuthGroupList: '/cms/authgroup/queryAccountAuthGroupList.json', //查询已绑定权限组
    queryAccountNoAuthGroupList: '/cms/authgroup/queryAccountNoAuthGroupList.json', //查询未绑定权限组
    updateAccountAuthGroup: '/cms/authgroup/updateAccountAuthGroup.json', //修改账号绑定权限组

    querySecurityWorkGroup: '/cms/workgroup/querySecurityWorkGroup.json', //工作组查询
  },
}